import { Action } from 'redux';

import { SetDescription } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../models/IContentInfo';

export interface SetDescriptionAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'> | IContentInfo<'contentRelayPlan'>;
}

export function setDescriptionAction(item: IContentInfo<'database'> | IContentInfo<'table'> | IContentInfo<'virtualConnection'> | IContentInfo<'virtualConnectionTable'> | IContentInfo<'contentRelayPlan'>): SetDescriptionAction {
  return {
    type: SetDescription,
    item
  };
}
